import React from "react";
import Layout from "./layout";
import { replaceQuotationMarksWithGuillemets } from "../util/format/guillemets";
var ContentPage = function ContentPage(_ref) {
    var title = _ref.title, content = _ref.content;
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full border-t-8 border-solid border-makroOrange lg:w-2/3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl lg:text-2xl text-makroOrange uppercase"
    }, replaceQuotationMarksWithGuillemets(title)), /*#__PURE__*/ React.createElement("div", {
        className: "content-text pb-8 px-3 lg:px-8",
        dangerouslySetInnerHTML: {
            __html: content
        }
    }))));
};
export default ContentPage;
